import { render, staticRenderFns } from "./PaiementTest.vue?vue&type=template&id=e6785f98&"
import script from "./PaiementTest.vue?vue&type=script&lang=ts&"
export * from "./PaiementTest.vue?vue&type=script&lang=ts&"
import style0 from "./PaiementTest.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports